'use client'

import { useRef, useEffect } from 'react'

const EmbedHtml = ({ html }: { html: string }) => {
  const elem = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (elem.current) {
      elem.current.innerHTML = ''
      elem.current.prepend(document.createRange().createContextualFragment(html))
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <div ref={elem}></div>
}

export default EmbedHtml
